import BackgroundWrapper from '../../components/background/index.jsx';
import Logo from '../../components/logo/index.jsx';
import Menu from '../../components/menu/index.jsx';
import Options from '../../components/options/index.jsx';
import { CenterContainer } from './style';
import SoundIcon from '../../components/soundIcon/index.jsx';
import { useState, useCallback } from 'react';

const HomeScreen = (props) => {
    const { setCurrentScreen } = props;
    const [soundOn, setSoundOn] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const forceUpdate = useCallback((soundSFX) => {
        setSoundOn(soundSFX)
    }, []);
    
    const toggleSound = () => {
        setSoundOn(window.backgroundSFX.playingEnabled = !soundOn);
        if(!soundOn) {
            window.backgroundSFX.play();
        } else {
            window.backgroundSFX.pause();
        }
    }

    return (
        <BackgroundWrapper backgroundImg={ 'assets/bgImgs/mainScreen.webp' } alignItems={ 'center' }>
            { showOptions && <Options closeFn={setShowOptions} updateParent={forceUpdate} /> }
            <SoundIcon soundOn={soundOn} clickAction={toggleSound} />
            <CenterContainer>
                <Logo />
                <Menu 
                    changeScreen={setCurrentScreen}
                    triggerOptions={setShowOptions} />
            </CenterContainer>
        </BackgroundWrapper>
    )
}
export default HomeScreen